import React, { createContext, useContext, ReactNode } from 'react';
import ApiClient from '../../lib/api-client';
import { IContractTemplateCreationDTO } from '@common-frontend-submodule/interfaces/contract-template/icontract-template-creation.interface';
import { IContractTemplateDTO } from '@common-frontend-submodule/interfaces/contract-template/icontract-template.interface';
import { IApiResponseGenericDTO } from '@common-frontend-submodule/interfaces/common/iapi-response.interface';
import { ContractTemplateRoutes } from '@common-frontend-submodule/enums/routes/contract-template-routes.enum';

const apiClient = ApiClient.getInstance()

interface ContractTemplateContextProps {
  getById: (id: string) => Promise<IApiResponseGenericDTO<IContractTemplateDTO>>;
  getAll: () => Promise<IApiResponseGenericDTO<IContractTemplateDTO[]>>;
  delete: (contractId: string) => Promise<IApiResponseGenericDTO<boolean>>;
  create: (file: File, model: IContractTemplateCreationDTO) => Promise<IApiResponseGenericDTO<IContractTemplateDTO>>;
}

const ContractTemplateContext = createContext<ContractTemplateContextProps | undefined>(undefined);

export const ContractTemplateProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const getById = async (id: string): Promise<IApiResponseGenericDTO<IContractTemplateDTO>> => {
    return await apiClient.getRequest<IContractTemplateDTO>(`${ContractTemplateRoutes.BasePrefix}/${id}`);
  };

  const getAll = async (): Promise<IApiResponseGenericDTO<IContractTemplateDTO[]>> => {
    return await apiClient.getRequest<IContractTemplateDTO[]>(`${ContractTemplateRoutes.BasePrefix}/all`);
  };

  const create = async (file: File, model: IContractTemplateCreationDTO): Promise<IApiResponseGenericDTO<IContractTemplateDTO>> => {
    const formData = new FormData();

    formData.append('files', file);

    Object.entries(model).forEach(([key, value]) => {
      formData.append(key, value as string); // Преобразуем значение в строку
    });
  
    return await apiClient.postFormDataRequest<FormData, IContractTemplateDTO>(
      ContractTemplateRoutes.BasePrefix,
      formData,
    );
  };

  const deleteTemplateFile = async (id: string): Promise<IApiResponseGenericDTO<boolean>> => {
    return await apiClient.deleteRequest<null, boolean>(`${ContractTemplateRoutes.BasePrefix}/${id}`);
  };

  return (
    <ContractTemplateContext.Provider value={{ getById, getAll, create, delete: deleteTemplateFile }}>
      {children}
    </ContractTemplateContext.Provider>
  );
};

export const useContractTemplateStore = () => {
  const context = useContext(ContractTemplateContext);
  if (!context) {
    throw new Error('useContractTemplateStore must be used within a useContractTemplateStore');
  }
  return context;
};
